// extracted by mini-css-extract-plugin
export var card = "_8x-0";
export var failedIcon = "_8x-4";
export var failedIconBadge = "_8x-3";
export var icon = "_8x-1";
export var successIcon = "_8x-2";